Shopify.onItemAdded = async function(cartItem) {
  const giftBoxCheckBox = document.getElementById("confirm-buy-gift")
  const checked = giftBoxCheckBox?.checked
  if (checked) {
    const variantId = giftBoxCheckBox.dataset.variantid
    
    const formData = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    } 
    
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
  }
  document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
}

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

waitForElm(".tee-form-action").then((elm) => {
  $(".tee-form-header").css({display: "none"});
  // document.querySelectorAll(".tee-variants .tee-radio.active")
  //   .forEach((el) => {
  //     el.style.setProperty("outline-color", "#151515", "important");
  //   });

  [".tee-field .tee-photo-action .tee-btn", ".tee-photo-action .tee-song__btn"].forEach(selector => {
    document.querySelectorAll(selector)
      ?.forEach((el) => {
        el.style.setProperty("background", "#ff8331", "important");
      });
  })

  // .tee-btn--preview:hover, .tee-btn--preview:focus, .tee-btn--preview:active
  // event :hover
  document.querySelectorAll(".tee-btn--preview")
    .forEach((el) => {
      el.style.setProperty("color", "#ff8331", "important");
      el.addEventListener("mouseenter", () => {
        el.classList.add("is-hover");
      });

      el.addEventListener("mouseleave", () => {
        el.classList.remove("is-hover");
      });
      
    });

  document.querySelectorAll(".tee-btn.tee-btn--atc")
    .forEach((el) => {
      el.style.setProperty("background", "#ff8331", "important");
      el.addEventListener("mouseenter", () => {
        el.classList.add("is-hover");
      });

      el.addEventListener("mouseleave", () => {
        el.classList.remove("is-hover");
      });
      
    });
});

waitForElm(".tee-btn.tee-btn--full.tee-btn--personalize").then((elm) => {
  const previewBtn = elm.querySelector("span")
  if (previewBtn) {
    previewBtn.textContent = "Preview Your Personalization"
  }
})

function initCustomUpload() {
  // Translations
  const translations = {
    en: {
      title: "Smart AI Filter",
      text: "Your image is getting ready",
      subtext: "Almost done — just a few seconds left"
    },
    de: {
      title: "Intelligenter KI-Filter",
      text: "Dein Bild wird vorbereitet",
      subtext: "Fast geschafft — nur noch ein paar Sekunden"
    },
    fr: {
      title: "Filtre IA Intelligent",
      text: "Votre image est en préparation",
      subtext: "Presque terminé — encore quelques secondes"
    }
  };

  const lang = window.TIB_LOCALE || document.documentElement.lang || 'en';
  const locale = lang.substring(0, 2).toLowerCase();
  const t = translations[locale] || translations.en;

  // CSS for the custom popup
  const css = `
    .animated-ai-logo {
      display: block;
      animation: tib-ai-hue-rotate 5s linear infinite, tib-ai-scale 5s ease-in-out infinite;
    }

    @keyframes tib-ai-hue-rotate {
      0% { filter: hue-rotate(0deg); }
      100% { filter: hue-rotate(360deg); }
    }

    @keyframes tib-ai-scale {
      0%, 100% { transform: scale(.9); }
      50% { transform: scale(1.4); }
    }

    @media (prefers-reduced-motion: reduce) {
      .animated-ai-logo { animation: none; }
    }

    .tib-ai-modal-backdrop {
      align-items: center;
      background: rgba(0, 0, 0, .85);
      display: flex;
      height: 100dvh;
      justify-content: center;
      left: 0;
      position: fixed;
      top: 0;
      transition: background .2s;
      width: 100vw;
      z-index: 999999999;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s ease;
    }

    .tib-ai-modal-backdrop.tib-active {
      opacity: 1;
      pointer-events: auto;
    }

    .tib-ai-modal-content {
      font-family: 'Poppins', sans-serif;
      animation: tib-modal-slide-down-in .3s cubic-bezier(.4, 0, .2, 1);
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 32px rgba(0, 0, 0, .18);
      overflow-y: auto;
      position: relative;
      width: 400px;
      max-width: 95vw;
      height: 500px;
      max-height: 95vh;
      display: flex;
      flex-direction: column;
    }

    @keyframes tib-modal-slide-down-in {
      0% { opacity: 0; transform: translateY(-100px) }
      to { opacity: 1; transform: translateY(0) }
    }

    @keyframes tib-modal-slide-up-out {
      0% { opacity: 1; transform: translateY(0) }
      to { opacity: 0; transform: translateY(-100px) }
    }

    .tib-ai-modal-content.tib-closing {
      animation: tib-modal-slide-up-out .3s cubic-bezier(.4, 0, .2, 1) forwards
    }

    @media(max-width: 767px) {
      .tib-ai-modal-content {
        border-radius: 12px;
        padding-bottom: env(safe-area-inset-bottom, 24px);
      }
    }

    .tib-ai-loading-step {
      background: #fff;
      flex: 1;
      flex-direction: column;
      padding: 20px 20px 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .tib-ai-video-container {
      height: 240px;
      margin-bottom: 20px;
      width: 240px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .tib-ai-sparkle {
      animation: tib-pulse-glow 2s ease-in-out infinite;
      max-width: 200px;
    }

    .tib-ai-sparkle.icon {
      width: auto !important;
      height: auto !important;
    }

    @keyframes tib-pulse-glow{
      0% {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, .3));
        opacity: .7;
        transform: scale(.9);
      }
      50% {
        filter: drop-shadow(0 0 15px rgba(255, 255, 255, .8));
        opacity: 1;
        transform: scale(1.4);
      }
      100% {
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, .3));
        opacity: .7;
        transform: scale(.9);
      }
    }


    .tib-ai-text {
      color: #666;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 12px;
      text-align: center;
    }

    .tib-ai-text strong {
      display: inline-block;
      font-feature-settings: "tnum";
      font-variant-numeric: tabular-nums;
      min-width: 50px;
      text-align: left;
    }

    .tib-ai-progress-bar {
      --progress-gradient-width: 560px;
      --progress-gradient-shift: 280px;
      background: hsla(0, 0%, 86%, .5);
      border-radius: 4px;
      height: 8px;
      margin-bottom: 20px;
      overflow: hidden;
      position: relative;
      width: 100%;
    }

    .tib-ai-progress-bar:after,
    .tib-ai-progress-bar:before {
      background-repeat: repeat-y;
      background-size: 100% 52%;
      bottom: -140%;
      content: "";
      height: 280%;
      left: -20%;
      pointer-events: none;
      position: absolute;
      width: 140%;
      will-change: transform;
      z-index: 2;
    }

    .tib-ai-progress-bar:before {
      animation: tib-progress-bubbles-vertical-1 3.2s linear infinite;
      background-image: radial-gradient(circle at 4% 95%, hsla(0, 0%, 100%, .27) 0 1.8px, transparent 2.4px), radial-gradient(circle at 11% 72%, hsla(0, 0%, 100%, .2) 0 .8px, transparent 1.4px), radial-gradient(circle at 18% 49%, hsla(0, 0%, 100%, .24) 0 1.4px, transparent 2px), radial-gradient(circle at 26% 88%, hsla(0, 0%, 100%, .22) 0 1.1px, transparent 1.7px), radial-gradient(circle at 33% 63%, hsla(0, 0%, 100%, .29) 0 1.9px, transparent 2.5px), radial-gradient(circle at 40% 37%, hsla(0, 0%, 100%, .16) 0 .8px, transparent 1.3px), radial-gradient(circle at 49% 82%, hsla(0, 0%, 100%, .21) 0 1.2px, transparent 1.8px), radial-gradient(circle at 57% 55%, hsla(0, 0%, 100%, .25) 0 1.6px, transparent 2.2px), radial-gradient(circle at 64% 28%, hsla(0, 0%, 100%, .18) 0 .9px, transparent 1.5px), radial-gradient(circle at 71% 92%, hsla(0, 0%, 100%, .22) 0 1.3px, transparent 1.9px), radial-gradient(circle at 79% 66%, hsla(0, 0%, 100%, .2) 0 1px, transparent 1.6px), radial-gradient(circle at 86% 41%, hsla(0, 0%, 100%, .24) 0 1.5px, transparent 2.1px), radial-gradient(circle at 93% 84%, hsla(0, 0%, 100%, .2) 0 1.1px, transparent 1.7px), radial-gradient(circle at 98% 60%, hsla(0, 0%, 100%, .23) 0 1.4px, transparent 2px);
      opacity: .82;
    }

    .tib-ai-progress-bar:after {
      animation: tib-progress-bubbles-vertical-2 4.4s linear infinite;
      animation-delay: -2.7s;
      background-image: radial-gradient(circle at 8% 80%, hsla(0, 0%, 100%, .2) 0 1px, transparent 1.6px), radial-gradient(circle at 14% 57%, hsla(0, 0%, 100%, .14) 0 .8px, transparent 1.4px), radial-gradient(circle at 23% 32%, hsla(0, 0%, 100%, .19) 0 1.2px, transparent 1.8px), radial-gradient(circle at 31% 88%, hsla(0, 0%, 100%, .18) 0 1px, transparent 1.6px), radial-gradient(circle at 40% 62%, hsla(0, 0%, 100%, .23) 0 1.6px, transparent 2.2px), radial-gradient(circle at 47% 41%, hsla(0, 0%, 100%, .16) 0 .9px, transparent 1.5px), radial-gradient(circle at 55% 77%, hsla(0, 0%, 100%, .19) 0 1px, transparent 1.6px), radial-gradient(circle at 64% 54%, hsla(0, 0%, 100%, .17) 0 1.2px, transparent 1.8px), radial-gradient(circle at 72% 29%, hsla(0, 0%, 100%, .22) 0 1.5px, transparent 2.1px), radial-gradient(circle at 82% 83%, hsla(0, 0%, 100%, .18) 0 1.1px, transparent 1.7px), radial-gradient(circle at 90% 58%, hsla(0, 0%, 100%, .21) 0 1.3px, transparent 1.9px), radial-gradient(circle at 97% 35%, hsla(0, 0%, 100%, .2) 0 1.4px, transparent 2px);
      opacity: .68;
    }

    .tib-ai-progress-fill {
      background: #525cf4;
      border-radius: 3px;
      height: 100%;
      overflow: hidden;
      position: relative;
      transition: width .2s linear;
      z-index: 1;
      display: block !important;
    }

    .tib-ai-progress-fill:before {
      animation: tib-progress-fill-gradient-shift 3.2s linear infinite;
      background: linear-gradient(90deg, #525cf4, #886bb7 25%, #525cf4 50%, #886bb7 75%, #525cf4);
      content: "";
      inset: 0 auto 0 0;
      position: absolute;
      width: var(--progress-gradient-width);
      will-change: transform;
    }

    @keyframes tib-progress-bubbles-vertical-1 {
      0% { transform: translateZ(0) }
      to { transform: translate3d(0, -52%, 0) }
    }

    @keyframes tib-progress-bubbles-vertical-2 {
      0% { transform: translate3d(0, -10%, 0) }
      to { transform: translate3d(0, -62%, 0) }
    }

    @keyframes tib-progress-fill-gradient-shift {
      0% { transform: translate3d(calc(var(--progress-gradient-shift)*-1), 0, 0) }
      to { transform: translateZ(0) }
    }

    .tib-ai-subtext {
      color: rgba(51, 51, 51, .6);
      font-size: 14px;
      text-align: center;
    }

    .tib-ai-modal-header {
      align-items: center;
      background: #fff;
      display: flex;
      justify-content: center;
      padding: 16px 20px;
      position: relative;
    }

    .tib-ai-modal-title {
      color: #666;
      font-size: 20px;
      font-weight: 600;
      text-align: center;
    }

    .tib-ai-close-btn {
      display: none;
    }

    .tib-ai-modal-body {
      background: #000;
      display: flex;
      flex: 1;
      flex-direction: column;
      overflow: hidden;
    }
  `;

  // Inject CSS
  const styleEl = document.createElement('style');
  styleEl.innerHTML = css;
  document.head.appendChild(styleEl);

  // HTML Structure
  const html = `
    <div class="tib-ai-modal-backdrop">
      <div class="tib-ai-modal-content tib-ai-modal-content--fullscreen-mobile">
        <div class="tib-ai-modal-header">
          <span class="tib-ai-modal-title">${t.title}</span>
          <button type="button" class="tib-ai-close-btn" aria-label="Close">✕</button>
        </div>
        <div class="tib-ai-modal-body">
          <div class="tib-ai-loading-step">
            <div class="tib-ai-video-container">

              <svg xmlns="http://www.w3.org/2000/svg" class="tib-ai-sparkle animated-ai-logo" width="90" height="90" viewBox="0 0 48 48" fill="none">

                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7196 5.05633C10.3531 5.05341 9.69065 5.04812 9.51989 5.07382C7.07784 5.25929 4.9709 6.16838 3.35285 8.05391C2.30942 9.26982 1.62105 10.7497 1.36329 12.331C1.2312 13.134 1.24412 14.7258 1.2535 15.8825C1.25567 16.1499 1.25765 16.3941 1.25761 16.5999L1.25752 37.4159C1.25755 37.5394 1.25711 37.6652 1.25667 37.7923C1.25454 38.4038 1.2523 39.0478 1.30165 39.6355C1.51279 41.9151 2.61988 44.0177 4.37983 45.4818C5.54317 46.4713 6.95106 47.1292 8.4561 47.3876C9.3712 47.5413 11.1457 47.5247 12.4391 47.5125L12.44 47.5125C12.7436 47.5096 13.0207 47.507 13.2539 47.507L34.6599 47.5051C34.7844 47.5051 34.9092 47.5056 35.0341 47.5062H35.0349C35.621 47.5086 36.2101 47.5111 36.7897 47.4595C40.4688 47.1306 43.7287 44.1416 44.3718 40.5035C44.5718 39.371 44.5563 38.1006 44.5415 36.8961C44.5379 36.6023 44.5344 36.3122 44.534 36.0292L44.5294 29.6818L44.5326 25.3185C44.5327 25.1446 44.5338 24.97 44.5349 24.795C44.5385 24.2114 44.5422 23.6237 44.5096 23.0455C44.464 22.2404 43.6591 21.6755 42.8852 21.7942C42.4927 21.8553 42.1421 22.0749 41.9163 22.4018C41.6141 22.8423 41.6446 24.0198 41.6654 24.8212L41.6654 24.823C41.6698 24.9908 41.6737 25.142 41.674 25.2665L41.6809 35.8781C41.681 36.0874 41.6837 36.3266 41.6867 36.5844L41.6867 36.5849C41.7003 37.77 41.7184 39.3463 41.5031 40.2063C41.2451 41.2383 40.7093 42.18 39.9547 42.9295C39.1084 43.773 38.0295 44.3443 36.8561 44.571C36.3509 44.6689 35.1074 44.6624 34.3464 44.6584H34.3455L34.2729 44.658C34.2374 44.6578 34.2032 44.6577 34.1703 44.6575C34.1101 44.6573 34.0545 44.6571 34.0044 44.6571L10.4109 44.6566C8.56441 44.6447 7.13667 44.2379 5.79743 42.8779C4.97449 42.033 4.42304 40.9614 4.21384 39.8005C4.10293 39.1817 4.11186 38.0822 4.11865 37.2467C4.12017 37.0595 4.12158 36.8855 4.12152 36.7332L4.12142 31.6084C4.12171 30.3477 4.12199 29.0869 4.12226 27.8259L4.12227 27.7752C4.12328 23.1684 4.12429 18.5598 4.1258 13.9538C4.1264 12.2289 4.66878 10.7548 5.92421 9.53721C6.67547 8.8059 7.61161 8.29278 8.63223 8.0529C9.41262 7.8773 11.4532 7.89671 12.7711 7.90924C13.0537 7.91193 13.303 7.9143 13.4996 7.91437L22.0277 7.9152C22.2796 7.91549 22.5392 7.91695 22.7952 7.91838C23.0552 7.91984 23.3117 7.92128 23.5531 7.92146C23.6378 7.92153 23.7265 7.92313 23.8178 7.92477C24.5436 7.93783 25.4355 7.95388 25.8054 7.2318C26.4545 5.96641 25.5221 5.04166 24.2727 5.05203L13.7152 5.06156L10.9041 5.05756C10.8606 5.05746 10.7966 5.05695 10.7196 5.05633Z" fill="url(#aiAnimatedGradient)"/>

                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.1839 16.8546L17.7602 16.8538L13.0261 30.2047C12.818 30.7926 12.6095 31.3898 12.3998 31.9904C11.8969 33.4308 11.3873 34.8906 10.861 36.2877L14.1974 36.2882C14.399 35.7236 14.6119 35.1433 14.8264 34.5586C15.2079 33.519 15.5945 32.4653 15.9316 31.461L22.2475 31.4624L24 31.4633C24.1894 31.9873 24.3832 32.5159 24.5776 33.0463C24.9739 34.1271 25.3727 35.215 25.7423 36.2849L29.0662 36.2872L24.879 24.4514C24.6022 23.6687 24.3253 22.8719 24.0469 22.0709C23.438 20.3188 22.8219 18.546 22.1839 16.8546ZM19.9557 20.06C20.0826 20.257 20.3837 21.1639 20.5911 21.7885L20.5915 21.7896C20.6625 22.0036 20.7225 22.1843 20.7607 22.2919L22.9703 28.4637H20.0474L16.9635 28.4628L19.9557 20.06Z" fill="url(#aiAnimatedGradient)"/>

                <path d="M31.9027 16.8577L34.9322 16.8569L34.9304 36.2868L31.9036 36.2864L31.9027 16.8577Z" fill="url(#aiAnimatedGradient)"/>

                <path d="M37.3397 1.04047C37.3992 1.11565 37.6581 2.27172 37.7272 2.50796C38.5855 5.42918 40.3605 6.11087 43.1896 6.71245C39.3502 7.34549 38.1639 8.62013 37.3969 12.3622L37.3789 12.3907C37.2983 12.3378 37.2075 11.7932 37.1804 11.6676C36.4409 8.26526 34.8391 7.34083 31.5834 6.71277C35.3896 5.93304 36.5538 4.87501 37.3397 1.04047Z" fill="url(#aiAnimatedGradient)"/>

                <path d="M43.1293 9.13757C43.3923 9.89334 43.414 10.4203 43.8899 11.1691C44.5091 12.1439 45.6889 12.481 46.7655 12.7057C46.0533 12.9406 45.5088 12.9531 44.7892 13.3893C43.6881 14.0563 43.4269 15.1325 43.1422 16.3021C43.0809 16.1632 42.9938 15.8135 42.9565 15.6523C42.4848 13.6077 41.3768 13.1365 39.4723 12.7251C41.9573 12.1398 42.5502 11.6356 43.1293 9.13757Z" fill="url(#aiAnimatedGradient)"/>

                <path d="M43.0967 0.480042C43.2317 0.619494 43.4063 1.40369 43.5583 1.65274C43.9453 2.28629 44.6736 2.49153 45.3393 2.65761C43.8375 2.99898 43.532 3.36394 43.1395 4.83554C42.9981 4.56198 42.9078 3.96418 42.6208 3.54357C42.1988 2.92444 41.6321 2.82332 40.948 2.65079C42.4066 2.26804 42.7631 1.95717 43.0967 0.480042Z" fill="url(#aiAnimatedGradient)"/>

                <defs>
                  <linearGradient id="aiAnimatedGradient" x1="1.24805" y1="5.04083" x2="40.7987" y2="45.3977" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stop-color="#15ECE4"/>
                    <stop offset="31.8624%" stop-color="#2967D5"/>
                    <stop offset="67.3876%" stop-color="#5F25D1"/>
                    <stop offset="100%" stop-color="#9121E5"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div>
              <div class="tib-ai-text">${t.text} <strong class="tib-ai-percent-text">(0%)</strong></div>
              <div class="tib-ai-progress-bar">
                <div class="tib-ai-progress-fill" style="width: 0%;"></div>
              </div>
              <div class="tib-ai-subtext">${t.subtext}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  // Append HTML to body
  const container = document.createElement('div');
  container.id = 'tib-ai-popup-container';
  container.innerHTML = html;
  document.body.appendChild(container);

  const backdrop = container.querySelector('.tib-ai-modal-backdrop');
  const modalContent = container.querySelector('.tib-ai-modal-content');
  const percentText = container.querySelector('.tib-ai-percent-text');
  const progressFill = container.querySelector('.tib-ai-progress-fill');

  // ---- Progress tu chay: nhich deu, khong tut lui, khong dung yen ----
  // Truoc day ham nay ve thang gia tri tho cua app Teeinblue -> so nhay cuc
  // (0 -> 5 -> 13 -> 16 ...) va dung im o 97% trong luc cho tai anh ket qua ve.
  // Gio: app chi SET MOC (targetPct), con ticker rieng tu bo len tung nhip.
  // % cua app (SDK Teeinblue) da chay theo eta: 95 * (1 - e^(-2.2 * t / T)),
  // T = thoi gian da troi + eta_ms + 1s -> toi moc eta ~85%, sau do bo dan toi 95%.
  const TICK_MS = 200;    // nhip dem
  const LERP = 0.3;       // moi nhip tien 30% khoang cach toi % cua app
  const CRAWL = 0.05;     // da bat kip app -> bo ~0.25%/s cho khoi dung im
  const HARD_CAP = 99;    // tran tuyet doi truoc khi xong that -> luon con cho nhich
  const START_CAP = 15;   // fallback khi khong doc duoc % cua app -> van nhich tu dau
  const EASE_K = 0.015;   // he so ease cho fallback (buoc dau ~1%, sau cham dan)
  const MIN_STEP = 0.02;  // buoc toi thieu -> khong bao gio dung han
  let shownPct = 0;       // % dang hien tren man hinh
  let targetPct = 0;      // % that lay tu app, chi dung lam moc
  let finishing = false;  // da xong that -> ve dich
  let tickerId = null;

  function renderProgress() {
    percentText.textContent = `(${Math.round(shownPct)}%)`;
    progressFill.style.width = `${shownPct}%`;
  }

  // Giu nguyen ten + chu ky ham: cho goi tu checkTeeinblueLoading()
  function updateProgress(percent) {
    let val = percent;
    if (typeof val === 'string') {
      val = val.replace('%', '').trim();
    }
    val = parseFloat(val);
    if (!isFinite(val)) return;
    if (val > targetPct) targetPct = Math.min(100, val);   // khong bao gio tut lui
  }

  function tickProgress() {
    if (finishing) {
      shownPct = Math.min(100, shownPct + 2);
    } else {
      const appPct = Math.min(targetPct, HARD_CAP);

      if (shownPct < appPct) {
        // bam sat app: tien 30% khoang cach moi nhip -> muot ma khong tre
        shownPct = Math.min(appPct, shownPct + Math.max(MIN_STEP, (appPct - shownPct) * LERP));
      } else if (targetPct <= 0) {
        // khong doc duoc % cua app -> ease ve START_CAP cho thanh van chay
        const step = Math.min(1, Math.max(MIN_STEP, (START_CAP - shownPct) * EASE_K));
        shownPct = Math.min(START_CAP, shownPct + step);
      } else {
        // da bat kip app (vd qua moc eta, app gan dung yen) -> bo cham toi HARD_CAP
        shownPct = Math.min(HARD_CAP, shownPct + CRAWL);
      }
    }
    renderProgress();
    if (shownPct >= 100) stopTicker();
  }

  function startTicker() {
    if (!tickerId) tickerId = setInterval(tickProgress, TICK_MS);
  }

  function stopTicker() {
    if (tickerId) {
      clearInterval(tickerId);
      tickerId = null;
    }
  }

  function showPopup() {
    if (!backdrop.classList.contains('tib-active')) {
      backdrop.classList.add('tib-active');
      modalContent.classList.remove('tib-closing');
      startTicker();
    }
  }

  function hidePopup() {
    if (backdrop.classList.contains('tib-active')) {
      // cho khach thay chay het 100% truoc khi dong (CSS da co transition .2s)
      finishing = true;
      shownPct = 100;
      renderProgress();
      modalContent.classList.add('tib-closing');
      setTimeout(() => {
        backdrop.classList.remove('tib-active');
        stopTicker();
        shownPct = 0;
        targetPct = 0;
        finishing = false;
        renderProgress();
      }, 300);
    }
  }

  // Monitor Teeinblue form
  let showTimeout = null;
  
  function checkTeeinblueLoading() {
    const loadingEl = document.querySelector('.tee-field--photo .tee-progress--loading');
    const isModalOpen = document.querySelector('.tee-dialog-image-cropper') ||
                        document.querySelector('.tee-dialog-image-placement');
    
    if (loadingEl && !isModalOpen) {
      // If not yet active and no timeout scheduled, schedule one
      if (!backdrop.classList.contains('tib-active') && !showTimeout) {
        showTimeout = setTimeout(() => {
          const stillLoading = document.querySelector('.tee-field--photo .tee-progress--loading');
          const noModalNow = !document.querySelector('.tee-dialog-image-cropper') &&
                             !document.querySelector('.tee-dialog-image-placement');
          
          if (stillLoading && noModalNow) {
            showPopup();
          }
          showTimeout = null;
        }, 250); // Wait 250ms to avoid flicker
      }
      
      // Update progress even if popup is not visible yet
      const progressBar = loadingEl.querySelector('.tee-progress-bar');
      const percentSpan = loadingEl.querySelector('.tee-progress-percent');
      
      let progress = '0';
      
      if (progressBar) {
        progress = progressBar.getAttribute('aria-valuenow') || progressBar.style.width.replace('%', '');
      } else if (percentSpan) {
        progress = percentSpan.textContent.replace('%', '');
      }
      
      if (progress) {
        updateProgress(progress);
      }
    } else {
      // If loading stops or cropper opens, clear timeout and hide
      if (showTimeout) {
        clearTimeout(showTimeout);
        showTimeout = null;
      }
      hidePopup();
    }
  }

  // Use MutationObserver
  const observer = new MutationObserver((mutations) => {
    checkTeeinblueLoading();
  });

  // Function to start observing only the Teeinblue form
  function startObserving() {
    const form = document.querySelector('.tee-customization-form') || document.querySelector('#teeFormInputs');
    if (form) {
      observer.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
      checkTeeinblueLoading();
    }
  }

  // Listen to Teeinblue hook
  document.addEventListener("teeinblue-event-component-injected", () => {
    startObserving();
  });

  // Fallback: If script loads after event, or event not firing but form exists
  if (document.querySelector('.tee-customization-form') || document.querySelector('#teeFormInputs')) {
    startObserving();
  }

  // Also use a controlled interval as a fallback for 100% reliability, 
  // but only active when we know the form exists or after hook
  let intervalId;
  function startInterval() {
    if (!intervalId) {
      intervalId = setInterval(checkTeeinblueLoading, 500);
    }
  }

  document.addEventListener("teeinblue-event-component-injected", startInterval);
  if (document.querySelector('.tee-customization-form') || document.querySelector('#teeFormInputs')) {
    startInterval();
  }

}

document.addEventListener("teeinblue-event-component-injected", () => {
  initCustomUpload();
});

// function by more pack
(function () {
  // =============================================================================
  // GLOBAL CONFIGURATION & DEFAULTS
  // =============================================================================
  const defaults = {
    keyword: 'buy more save more',
    debug: false, // Enabled debug logs by default to assist troubleshooting
    selectors: '.header__icons [data-currency-converter], .header__icons #currency-convertor, .modal_area [data-currency-converter], .modal_area [data-native-currency-converter], [data-currency-converter], #currency-convertor',
    css: `
      #tee-artwork-form .tee-radio-label[data-wr-volume-injected] {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        margin: 4px 0 !important;
      }

      #tee-artwork-form .wr-column-qty {
        font-weight: 600;
      }

      #tee-artwork-form .wr-volume-unit-price {
        color: #79797b;
        font-weight: 400;
        line-height: 16px;
        font-size: 14px;
      }
    `
  };

  const settings = Object.assign({}, defaults, window.TIBVolumePricingConfig || {});

  // =============================================================================
  // STYLE SHEETS FOR QUANTITY BREAKS PRICE LABELS
  // =============================================================================
  (function injectVolumePricingStyle() {
    const STYLE_ID = 'wr-volume-pricing-style';
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = settings.css;
    document.head.appendChild(style);
  })();

  // =============================================================================
  // QUANTITY BREAKS PRICE INJECTOR
  // Target: Shopify option names matching the keyword
  // =============================================================================

  // Match patterns like: 1PC, 2 PCS, 2PACK, 3 ITEMS, 2 PAIR
  const QTY_UNIT_PATTERN = /^(\d+)\s*(pc|pack|item|pair)s?\b/i;

  let productDetails = null;
  let activeVariantId = null;
  let isVolumePricingActive = true;
  const domObservers = new WeakMap();

  function logDebug(...messages) {
    if (settings.debug) console.log('[TIB Log]', ...messages);
  }

  function isVolumePricingOption(optionName) {
    return String(optionName || '').toLowerCase().includes(settings.keyword);
  }

  // Pre-check options synchronously to avoid fetching data unnecessarily
  (function verifyVolumePricingRequirement() {
    const options = window.meta?.product?.options || 
                    window._MP_CONFIG_?.product?.options;
    if (options && Array.isArray(options)) {
      const hasVolumePricing = options.some(name => isVolumePricingOption(name));
      if (!hasVolumePricing) {
        logDebug('Pre-check: Product does not have volume pricing option. Disabling.');
        isVolumePricingActive = false;
      }
    }
  })();

  function extractQuantityDetails(optionValue) {
    const match = String(optionValue).trim().match(QTY_UNIT_PATTERN);
    if (!match) return null;

    const quantity = parseInt(match[1], 10);
    if (quantity < 1) return null;

    const unit = match[2].toLowerCase();
    const qtyLabel = quantity === 1 ? `1 ${unit}` : `${quantity} ${unit}s`;

    return {
      quantity,
      qtyLabel: qtyLabel.toUpperCase(),
      suffix: `/${unit}`,
    };
  }

  function getActiveVariantId() {
    if (activeVariantId) return activeVariantId;
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      const idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) {
        return idInput.value;
      }
    }
    return window.ShopifyAnalytics?.meta?.selectedVariantId || 
           window.meta?.product?.selectedVariantId;
  }

  function getVolumePricingConfig() {
    if (!productDetails) {
      logDebug('Product details are not loaded yet');
      return null;
    }

    const currentId = getActiveVariantId();
    logDebug('Currently selected variant ID:', currentId);
    if (!currentId) return null;

    const currentVariant = productDetails.variants.find(
      (v) => String(v.id) === String(currentId)
    );
    if (!currentVariant) {
      logDebug('Could not match variant in product metadata:', currentId);
      return null;
    }

    const optionIndex = (productDetails.options || []).findIndex((opt) => {
      const name = typeof opt === 'string' ? opt : opt?.name;
      return isVolumePricingOption(name);
    });
    if (optionIndex < 0) {
      logDebug('Volume pricing option not found. Disabling logic.');
      isVolumePricingActive = false;
      return null;
    }

    const pricingKey = `option${optionIndex + 1}`;
    
    // Dynamically identify the product base option (e.g. AVAILABLE PRODUCTS or option1)
    let baseKey = null;
    if (productDetails.options.length > 1) {
      const baseIndex = productDetails.options.findIndex(opt => {
        const name = typeof opt === 'string' ? opt : opt?.name;
        return String(name || '').toLowerCase().includes('product');
      });
      if (baseIndex >= 0 && `option${baseIndex + 1}` !== pricingKey) {
        baseKey = `option${baseIndex + 1}`;
      } else if (pricingKey !== 'option1') {
        baseKey = 'option1';
      }
    }
    logDebug('Pricing key:', pricingKey, 'Base key:', baseKey);

    // Group variants by the pricing option value and select the best matching variant for each.
    // This resolves sparse/linked option combinations (e.g. 1 PC is linked to Size DIN-A1, 3 PCS to DIN-A3).
    const bestMatches = new Map(); // key: pricing option value, value: { variant, score }

    for (const variant of productDetails.variants || []) {
      // Check if product base matches (if baseKey is active) to avoid cross-product pollution
      if (baseKey) {
        const baseVal1 = String(variant[baseKey] || '').trim().toLowerCase();
        const baseVal2 = String(currentVariant[baseKey] || '').trim().toLowerCase();
        if (baseVal1 !== baseVal2) {
          continue; 
        }
      }

      const optionValue = variant[pricingKey];
      if (!optionValue) continue;

      // Calculate matching score for other non-pricing options (e.g. Size, Style)
      let score = 0;
      for (let i = 0; i < productDetails.options.length; i++) {
        const key = `option${i + 1}`;
        if (key !== pricingKey && key !== baseKey) {
          const val1 = String(variant[key] || '').trim().toLowerCase();
          const val2 = String(currentVariant[key] || '').trim().toLowerCase();
          if (val1 === val2) {
            score += 1;
          }
        }
      }

      const existing = bestMatches.get(optionValue);
      if (!existing || score > existing.score) {
        bestMatches.set(optionValue, { variant, score });
      }
    }

    const priceMap = new Map();

    for (const [optionValue, match] of bestMatches.entries()) {
      const variant = match.variant;
      const qtyInfo = extractQuantityDetails(optionValue);
      if (!qtyInfo) continue;

      const rawPrice = Number(variant.price);
      const totalCents = Number.isFinite(rawPrice) && rawPrice > 0
        ? (String(variant.price).includes('.') ? Math.round(rawPrice * 100) : Math.round(rawPrice))
        : 0;
      if (totalCents <= 0) continue;

      const unitCents = Math.round(totalCents / qtyInfo.quantity);
      priceMap.set(optionValue, {
        unitCents: unitCents,
        qtyLabel: qtyInfo.qtyLabel,
        suffix: qtyInfo.suffix,
      });
      logDebug(`Mapped pricing value "${optionValue}" (qty ${qtyInfo.quantity}) to unit cents ${unitCents} using variant ${variant.id} (score ${match.score})`);
    }

    if (priceMap.size === 0) return null;

    const baseCurrency = window.Shopify?.currency?.active || 'USD';

    return {
      priceMap,
      baseCurrency: baseCurrency,
    };
  }

  // Helper to fetch details from map with case-insensitive and trim normalized lookup
  function getNormalizedPrice(priceMap, lookupKey) {
    const normalizedLookup = String(lookupKey || '').trim().toLowerCase();
    for (const [key, value] of priceMap.entries()) {
      if (String(key).trim().toLowerCase() === normalizedLookup) {
        return value;
      }
    }
    return null;
  }

  // Format unit price in base shop currency
  function formatBaseCurrencyPrice(cents, currency) {
    const amount = cents / 100;
    if (currency === 'VND') {
      return `${Math.round(cents).toLocaleString('vi-VN')}₫`;
    }
    return `$${amount.toFixed(2)}`;
  }

  // Remove the redundant ISO currency code (e.g. "USD", "EUR") that the
  // shop's money_format table appends/prepends for some currencies, while
  // leaving real symbols (Rs, kr, SFr, ...) untouched.
  function stripCurrencyCode(text, currencyCode) {
    if (!currencyCode) return text;
    return text.replace(new RegExp('\\s*\\b' + currencyCode + '\\b\\s*', 'g'), ' ').trim();
  }

  // Compute the unit price text for the currently active storefront currency.
  // Always derives from the stable `unitCents` value instead of re-reading
  // the DOM, so repeated calls (e.g. from a MutationObserver) can't
  // accumulate conversions on top of an already-converted price.
  function formatUnitPrice(unitCents, baseCurrency, activeCurrency) {
    if (!activeCurrency || activeCurrency === baseCurrency) {
      return formatBaseCurrencyPrice(unitCents, baseCurrency);
    }
    if (window.Currency && typeof window.Currency.convert === 'function' && typeof window.Currency.formatMoney === 'function') {
      try {
        const convertedCents = window.Currency.convert(unitCents, baseCurrency, activeCurrency);
        const formatString = (window.Currency.money_format || {})[activeCurrency] || '{{amount}}';
        const formatted = window.Currency.formatMoney(convertedCents, formatString);
        return stripCurrencyCode(formatted, activeCurrency);
      } catch (err) {
        logDebug('Currency conversion failed, falling back to base price', err);
      }
    }
    return formatBaseCurrencyPrice(unitCents, baseCurrency);
  }

  // Observers DOM modifications safely
  function watchVolumeOptionsDOM(optionContainer) {
    if (domObservers.has(optionContainer)) return;

    let debouncedTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(debouncedTimer);
      debouncedTimer = setTimeout(() => {
        optionContainer.querySelectorAll('.tee-radio-label[data-wr-volume-injected]').forEach((label) => {
          if (!label.querySelector('.wr-volume-unit-price')) delete label.dataset.wrVolumeInjected;
        });
        applyVolumePricingLabels();
      }, 50);
    });

    observer.observe(optionContainer, { childList: true, subtree: true });
    domObservers.set(optionContainer, observer);
  }

  function applyVolumePricingLabels() {
    if (!isVolumePricingActive) return;
    logDebug('applyVolumePricingLabels() triggered');
    const config = getVolumePricingConfig();
    if (!config) {
      logDebug('Pricing config not generated');
      return;
    }

    const pricingContainer = [...document.querySelectorAll('#tee-artwork-form .tee-option, .tee-variants .tee-option')].find(
      (container) => isVolumePricingOption(container.querySelector('.tee-option__title')?.textContent)
    );
    if (!pricingContainer) {
      logDebug('Could not find volume pricing options container in DOM');
      return;
    }

    watchVolumeOptionsDOM(pricingContainer);

    const activeCurrency = window.Currency?.currentCurrency || config.baseCurrency;

    for (const radio of pricingContainer.querySelectorAll('.tee-radio')) {
      const input = radio.querySelector('input[type="radio"]');
      const label = radio.querySelector('.tee-radio-label');
      if (!input || !label) continue;

      // Use normalized helper to tolerate whitespace/capitalization mismatches
      const details = getNormalizedPrice(config.priceMap, input.value);
      if (!details) {
        logDebug(`No matching price details found in map for value: "${input.value}"`);
        continue;
      }

      // Key on the base-currency amount + active currency, never on the
      // rendered text, so switching currency always triggers a fresh
      // conversion from the stable unitCents value (no compounding).
      const priceKey = `${config.baseCurrency}:${details.unitCents}:${activeCurrency}`;
      const displayPrice = formatUnitPrice(details.unitCents, config.baseCurrency, activeCurrency);

      // The theme's site-wide currency script (currencies.liquid) targets
      // every span.money by default and reformats it with its own
      // "$X.XX USD"-style text (e.g. on classic variant selectCallback).
      // Detect that drift by comparing the live DOM, not just our own
      // bookkeeping, so it gets repaired even when priceKey hasn't changed.
      const existingMoney = label.querySelector('.wr-volume-unit-price .wr-unit-money');
      if (
        label.dataset.wrVolumeInjected === '1' &&
        label.dataset.wrPriceKey === priceKey &&
        existingMoney &&
        existingMoney.innerHTML === displayPrice
      ) {
        continue;
      }

      label.replaceChildren();

      const qtySpan = document.createElement('span');
      qtySpan.className = 'wr-column-qty';
      qtySpan.textContent = details.qtyLabel;

      const priceSuffixSpan = document.createElement('span');
      priceSuffixSpan.className = 'wr-volume-unit-price';

      // Deliberately NOT class "money" — see comment above.
      const moneySpan = document.createElement('span');
      moneySpan.className = 'wr-unit-money';
      moneySpan.innerHTML = displayPrice;

      priceSuffixSpan.append(moneySpan, document.createTextNode(details.suffix));
      label.append(qtySpan, priceSuffixSpan);
      label.dataset.wrVolumeInjected = '1';
      label.dataset.wrPriceKey = priceKey;
    }
  }

  // =============================================================================
  // LOAD PRODUCT METADATA FROM API
  // =============================================================================
  async function loadProductMetadata() {
    try {
      const match = window.location.pathname.match(/\/products\/([^\/]+)/);
      if (!match) return;
      const handle = match[1];
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return;
      productDetails = await response.json();
      logDebug('Product metadata loaded:', productDetails);
      applyVolumePricingLabels();
    } catch (err) {
      console.error('[TIB] Failed to load product metadata:', err);
    }
  }

  // Fetch only if pre-check finds the pricing options
  if (isVolumePricingActive) {
    loadProductMetadata();
  }

  // =============================================================================
  // EVENT INTEGRATION
  // =============================================================================

  document.addEventListener('teeinblue-event-component-injected', () => {
    if (!isVolumePricingActive) return;
    applyVolumePricingLabels();
  });

  document.addEventListener('teeinblue-event-variant-changed', (e) => {
    if (!isVolumePricingActive) return;
    const variantId = e.detail?.variantId;
    logDebug('Active variant changed to:', variantId);
    if (variantId) {
      activeVariantId = String(variantId);
    }
    setTimeout(() => {
      applyVolumePricingLabels();
    }, 50);
  });

  // Intercept changes to currency selection elements
  document.addEventListener('change', (e) => {
    if (!isVolumePricingActive) return;
    if (e.target && e.target.matches(settings.selectors)) {
      logDebug('Currency selector change event detected');
      setTimeout(() => {
        applyVolumePricingLabels();
      }, 150);
    }
  });
})();

// =============================================================================
// "Best Seller" badge for Teeinblue Size options. Ported from the same
// feature in themeWRUS's sections/main-product-teeinblue.liquid — kept here
// instead of moved into the section (unlike themeWRUS) since this theme's
// Teeinblue integration doesn't have an equivalent inline <script> block to
// host it in; settings.list_skus_v2 and product.id, which only Liquid can
// read, are handed over via the small inline script added right after the
// opening tag of sections/main-product-teeinblue.liquid
// (window.__bestSellingSkusV2 / window.ShopifyAnalytics.meta.product.id —
// the latter Shopify already provides, no extra Liquid needed for it).
// Re-run on every Teeinblue render (component injected / variant changed),
// not just once on first appearance, since the widget can rebuild this DOM
// when the customer switches variants.
// =============================================================================
(function () {
  const STYLE_ID = 'tee-best-selling-style';

  function injectBestSellingStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .tee-option--size.best_selling .tee-radio:last-child .tee-radio-label,
      .tee-option--size.best_selling .tee-radio-label.bs-exact {
        position: relative;
      }
      .tee-option--size.best_selling .tee-radio:last-child .tee-radio-label::before,
      .tee-option--size.best_selling .tee-radio-label.bs-exact::before {
        position: absolute;
        content: "Best Seller";
        bottom: calc(100% - 7px);
        left: 50%;
        transform: translateX(-50%);
        width: max-content;
        max-width: none;
        background: #ff8831;
        color: #fff;
        padding: 3px 8px;
        border-radius: 10px;
        text-align: center;
        opacity: 0;
        pointer-events: none;
        font-size: 12px;
        white-space: nowrap;
        text-transform: capitalize;
      }
      .tee-option--size.best_selling.show .tee-radio:last-child .tee-radio-label::before,
      .tee-option--size.best_selling .tee-radio .tee-radio-label.bs-exact::before {
        opacity: 1;
      }
    `;
    document.head.appendChild(style);
  }

  // Text used to look up the size a SKU maps to, normalized so visually
  // equivalent labels (curly vs straight quotes, "x" vs "×", extra
  // whitespace) still match instead of silently falling through to the
  // catch-all last-radio badge.
  const normalizeSizeLabel = (s) => (s || '')
    .normalize('NFKC')
    .replace(/[‘’ʼ]/g, "'")
    .replace(/[“”]/g, '"')
    .replace(/[×✕✖]/g, 'x')
    .replace(/\s+/g, ' ')
    .trim();

  function applyBestSellingBadge() {
    const sizeOption = document.querySelector('.tee-option--size');
    if (!sizeOption) return;
    const radios = Array.from(sizeOption.querySelectorAll('.tee-radio'));

    // Reset previous state so re-runs don't leave a stale badge from an
    // earlier size selection.
    sizeOption.classList.remove('best_selling', 'show');
    radios.forEach((radio) => radio.querySelector('.tee-radio-label')?.classList.remove('bs-exact'));

    if (radios.length <= 1) return;
    injectBestSellingStyle();
    sizeOption.classList.add('best_selling');

    const variants = window.ShopifyAnalytics?.meta?.product?.variants;
    if (!variants) return;

    // SKU entries scoped to specific productIds always win over catch-all
    // (no productIds) entries when picking the exact size to highlight,
    // since the same SKU can be configured differently for different
    // products, and a product may match both a scoped and a catch-all
    // entry for two different sizes at once.
    let scopedMatchedSkus = new Set();
    let catchAllSkus = new Set();
    try {
      const LIST_SKUS_V2 = window.__bestSellingSkusV2 || [];
      const CURRENT_PRODUCT_ID = String(window.ShopifyAnalytics?.meta?.product?.id || '');
      const scopedSkuSet = new Set();
      LIST_SKUS_V2.forEach((entry) => {
        if (entry.productIds && entry.productIds.length > 0) {
          (entry.sku || []).forEach((s) => scopedSkuSet.add(s));
        }
      });
      LIST_SKUS_V2.forEach((entry) => {
        if (entry.productIds && entry.productIds.length > 0) {
          if (entry.productIds.map(String).includes(CURRENT_PRODUCT_ID)) {
            (entry.sku || []).forEach((s) => scopedMatchedSkus.add(s));
          }
        } else {
          (entry.sku || []).forEach((s) => {
            if (!scopedSkuSet.has(s)) catchAllSkus.add(s);
          });
        }
      });
    } catch (e) {
      scopedMatchedSkus = new Set();
      catchAllSkus = new Set();
    }

    const sizeOptionValues = radios.map((radio) => radio.querySelector('input[type="radio"]')?.value);
    let exactMatchSize = null;
    let catchAllExactMatchSize = null;
    let hasPartial = false;
    for (const variant of variants) {
      const { sku, public_title, name } = variant;
      if (!sku) continue;
      const parts = (public_title || name || '').split(' / ').map((p) => p.trim());
      if (scopedMatchedSkus.has(sku)) {
        exactMatchSize = sizeOptionValues.find((v) => parts.some((p) => normalizeSizeLabel(p) === normalizeSizeLabel(v))) || null;
        break;
      }
      if (catchAllSkus.has(sku) && catchAllExactMatchSize === null) {
        catchAllExactMatchSize = sizeOptionValues.find((v) => parts.some((p) => normalizeSizeLabel(p) === normalizeSizeLabel(v))) || null;
      }
      if ([...catchAllSkus].some((s) => sku.indexOf(s) !== -1)) hasPartial = true;
    }
    if (!exactMatchSize) exactMatchSize = catchAllExactMatchSize;

    if (exactMatchSize) {
      const matchRadio = radios.find((radio) => radio.querySelector('input[type="radio"]')?.value === exactMatchSize);
      if (matchRadio) {
        matchRadio.querySelector('.tee-radio-label')?.classList.add('bs-exact');
      } else {
        sizeOption.classList.add('show');
      }
    } else if (hasPartial) {
      sizeOption.classList.add('show');
    }
  }

  document.addEventListener('teeinblue-event-component-injected', applyBestSellingBadge);
  document.addEventListener('teeinblue-event-variant-changed', () => setTimeout(applyBestSellingBadge, 50));

  waitForElm('.tee-option--size').then(applyBestSellingBadge);
})();


(function () {
  let scheduled = false;

  function moveUploadInstruction() {
    const photo = document.querySelector('.tee-photo');
    const instruction = document.querySelector(
      '.tee-photo .tee-upload-instruction'
    );

    if (!photo || !instruction) return;

    // Tránh move lặp lại nếu nó đã nằm ngay sau .tee-photo
    if (photo.nextElementSibling === instruction) return;

    photo.insertAdjacentElement('afterend', instruction);
  }

  function scheduleMove() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      moveUploadInstruction();
    });
  }

  const observer = new MutationObserver(scheduleMove);

  function init() {
    moveUploadInstruction();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();







document.addEventListener("DOMContentLoaded", function () {
  if (window.__photoGuidelineInitialized) {
    return;
  }

  window.__photoGuidelineInitialized = true;

  /*
   * BẮT BUỘC:
   * Thay URL bên dưới bằng URL ảnh thật từ Shopify Files.
   */
  const GUIDELINE_IMAGE_URL =
    "https://cdn.shopify.com/s/files/1/0951/2301/3954/files/1_aa346831-a505-4633-a7bd-8180e5f7b722.png?v=1792473557";

  const MODAL_ID = "photo-guideline-modal";
  const BUTTON_CLASS = "photo-guideline-btn";
  const FIELD_CLASS = "photo-guideline-field";

  let lastTrigger = null;
  let injectScheduled = false;

  /*
   * Create modal
   */
  function createGuidelineModal() {
    const existingModal = document.getElementById(MODAL_ID);

    if (existingModal) {
      return existingModal;
    }

    const modalContainer = document.createElement("div");

    modalContainer.innerHTML = `
      <div
        id="${MODAL_ID}"
        class="photo-guideline-backdrop"
        aria-hidden="true"
      >
        <div
          class="photo-guideline-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Photo upload guidelines"
        >
          <button
            type="button"
            class="photo-guideline-close"
            aria-label="Close photo upload guidelines"
          ></button>

          <img
            class="photo-guideline-image"
            src="${GUIDELINE_IMAGE_URL}"
            alt="Photo upload guidelines"
          >
        </div>
      </div>
    `;

    const modal = modalContainer.firstElementChild;

    document.body.appendChild(modal);

    return modal;
  }

  const backdrop = createGuidelineModal();
  const closeButton = backdrop.querySelector(
    ".photo-guideline-close"
  );

  /*
   * Open modal
   */
  function openGuidelineModal(trigger) {
    lastTrigger = trigger || null;

    backdrop.classList.add("is-open");
    backdrop.setAttribute("aria-hidden", "false");

    document.documentElement.classList.add(
      "photo-guideline-lock"
    );

    document.body.classList.add(
      "photo-guideline-lock"
    );

    closeButton.focus();
  }

  /*
   * Close modal
   */
  function closeGuidelineModal() {
    if (!backdrop.classList.contains("is-open")) {
      return;
    }

    backdrop.classList.remove("is-open");
    backdrop.setAttribute("aria-hidden", "true");

    document.documentElement.classList.remove(
      "photo-guideline-lock"
    );

    document.body.classList.remove(
      "photo-guideline-lock"
    );

    if (lastTrigger && document.body.contains(lastTrigger)) {
      lastTrigger.focus();
    }

    lastTrigger = null;
  }

  /*
   * Inject guideline button into first photo field only
   */
  function injectGuidelineButton() {
    const photoFields = Array.from(
      document.querySelectorAll(
        ".tee-customization-form .tee-field--photo, " +
        "#teeFormInputs .tee-field--photo"
      )
    );

    if (!photoFields.length) {
      return;
    }

    const firstPhotoField = photoFields[0];

    /*
     * Remove marker and buttons from all fields after the first one.
     */
    photoFields.forEach(function (photoField, index) {
      const isFirstField = index === 0;

      photoField.classList.toggle(
        FIELD_CLASS,
        isFirstField
      );

      if (!isFirstField) {
        photoField
          .querySelectorAll("." + BUTTON_CLASS)
          .forEach(function (button) {
            button.remove();
          });
      }
    });

    const header = firstPhotoField.querySelector(
      ".tee-field__header"
    );

    const heading =
      firstPhotoField.querySelector(".tee-field__heading") ||
      header;

    if (!heading) {
      return;
    }

    /*
     * If Teeinblue replaced the header, move the existing
     * button into the new heading instead of creating a duplicate.
     */
    const existingButton =
      firstPhotoField.querySelector("." + BUTTON_CLASS);

    if (existingButton) {
      if (existingButton.parentElement !== heading) {
        heading.appendChild(existingButton);
      }

      return;
    }

    const button = document.createElement("button");

    button.type = "button";
    button.className = BUTTON_CLASS;
    button.setAttribute(
      "aria-controls",
      MODAL_ID
    );

    button.setAttribute(
      "aria-haspopup",
      "dialog"
    );

    button.innerHTML = `
      <span>Photo Guidelines</span>

      <svg
        viewBox="0 0 512 512"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M257 408 1 153l34-34 222 222 221-222 34 34z"
        ></path>
      </svg>
    `;

    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      openGuidelineModal(button);
    });

    heading.appendChild(button);
  }

  /*
   * Avoid executing injection repeatedly within the same frame.
   */
  function scheduleGuidelineInjection() {
    if (injectScheduled) {
      return;
    }

    injectScheduled = true;

    window.requestAnimationFrame(function () {
      injectScheduled = false;
      injectGuidelineButton();
    });
  }

  /*
   * Close button
   */
  closeButton.addEventListener(
    "click",
    closeGuidelineModal
  );

  /*
   * Click outside modal to close
   */
  backdrop.addEventListener("click", function (event) {
    if (event.target === backdrop) {
      closeGuidelineModal();
    }
  });

  /*
   * Escape key to close
   */
  document.addEventListener("keydown", function (event) {
    if (
      event.key === "Escape" &&
      backdrop.classList.contains("is-open")
    ) {
      closeGuidelineModal();
    }
  });

  /*
   * Teeinblue rendered event
   */
  document.addEventListener(
    "teeinblue-event-component-injected",
    scheduleGuidelineInjection
  );

  /*
   * Teeinblue can replace/re-render fields dynamically.
   */
  const observer = new MutationObserver(
    scheduleGuidelineInjection
  );

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
   * Initial injection
   */
  scheduleGuidelineInjection();
});